<button
  (click)="openIncidentsDialog($event)"
  class="label"
  [ngClass]="labelType"
  [disabled]="labelType === 'torn'"
  [attr.data-tracking-id]="'button-label-' + labelType"
>
  @if (incidentsLoading) {
    <mat-spinner [diameter]="16" class="mat-spinner-label"></mat-spinner>
  }

  @if (!incidentsLoading) {
    <p>{{ labelType }}</p>
  }
</button>
